export * from './testing/schema_registry_mock';
export * from './testing/view_resolver_mock';
export * from './testing/xhr_mock';
export * from './testing/test_component_builder';
export * from './testing/directive_resolver_mock';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
